<!-- 
<div *ngIf="items" >
      <span class="show-coppy-note" [class.active]=showCopyNote>{{ 'COPIED' | translate }}</span>
      <div *ngFor="let flatPropertie of flatProperties" class="flat-properties-container">
        <div class="flat-details-holder">

          <div *ngIf="items;else noItems" class="list-flats">
            <div *ngFor="let item of items" class="collection" class="flat dark-background">
              <ul class="general-flat-propeties">

                <li class="general-flat-floor-number"> <span>{{ 'FLOOR' | translate }}</span> {{ item.floorNumber }}</li>
                <li class="general-flat-area">
                  <span>{{ 'APARTMENT-AREA' | translate }}</span> {{ flatProperties.flatSize }}
                </li>
                <li class="general-flat-room-quantity"> 
                  <span>{{ 'NUMBER-OF-ROOMS' | translate }}</span> {{ flatProperties.numberOfRooms }}
                </li> 
              </ul>

    
            </div>
          </div>      
          <div *ngFor="let item of items">

          </div>
          <app-gallery [galleryId]="'1'" [section]="flatProperties.id+'interiorSimulations'" [autoPlay]="false"
            [showThumbs]="true" class="list-static flat-details"></app-gallery>
          <div *ngIf="flatProperties.freeText && flatProperties.freeText !== ' '" class="flat-properties dark-background">
            <h3 class="title second-title slide" [class.active]="slide" (click)="slide = !slide">{{ 'SPECIFICATION' | translate }}</h3>
            <ul [class.active]="showContent" class="flat-details-content">
              <li [innerHtml]="flatProperties.freeText | safe: 'html'">
    
              </li>
            </ul>

          </div>

            <div class="display-flex-row">
          <div *ngIf="items;else noItems" class="view-from-floor">
            <h3 _ngcontent-xci-c169="" class="title second-title ng-tns-c169-7">{{ 'VIEW-FROM-THE-FLOOR' | translate }}</h3>
            <div *ngFor="let item of items" class="collection" class="panorama-holder"
              [class.full-screen-view]="fullScreenSpirical">

              <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder" [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '?s=' + item.curFloorPanorama + '></iframe>' | safe: 'html'"></div>
              

                <div class="fullscreen-big-button" [class.active]="fullScreenSpirical" (click)="bigSpirical()">
                  <ul class="fullscreen" [class.fullscreenShow]="fullScreenSpirical">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                 <span *ngIf=!fullScreenSpirical> {{ 'ENLARGEMENT' | translate }} </span>
                 <span *ngIf=fullScreenSpirical> {{ 'REDUCTION' | translate }} </span>
                </div>
            </div>
          </div>
    
          <div *ngIf="items && this.flatProperties[0].flatInterior" class="view-from-floor">
            <h3 _ngcontent-xci-c169="" class="title second-title ng-tns-c169-7">{{ 'FLAT-INTERIOR' | translate }}</h3>
            <div *ngFor="let item of items" class="collection" class="panorama-holder"
              [class.full-screen-view]="fullScreenInterior">
              <div class="view-from-floor-panorama-holder flat-interior"
                [innerHtml]="'<iframe src=' + this.flatProperties[0].flatInterior + '></iframe>' | safe: 'html'">
              </div>
              <div class="fullscreen-big-button" [class.active]="fullScreenInterior" (click)="bigInterior()">
                <ul class="fullscreen" [class.fullscreenShow]="fullScreenInterior">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <span *ngIf=!fullScreenSpirical> {{ 'ENLARGEMENT' | translate }} </span>
                <span *ngIf=fullScreenSpirical> {{ 'REDUCTION' | translate }} </span>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="flat-details-drawing">
          <div class="">
            <div class="drawing" [class.full-screen-view-title]="fullScreenDrawing" href="javascript:;">
              <h3 class="title second-title">{{ 'FLAT-PLAN' | translate }}</h3>
            </div>

    
            <app-gallery [galleryId]="'1'" [section]="flatProperties.id+'images'" [resizeDrag]="true" [autoPlay]="true"
              [showThumbs]="true" class="list-static simple-gall build-simple-gal"
              [class.full-screen-view]="fullScreenDrawing"></app-gallery>
          </div>
          <div class="fullscreen-big-button" [class.active]="fullScreenDrawing" (click)="bigDrawing()"> 
            <ul class="fullscreen" [class.fullscreenShow]="fullScreenDrawing">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
           <span *ngIf=!fullScreenDrawing> {{ 'ENLARGEMENT' | translate }} </span>
           <span *ngIf=fullScreenDrawing> {{ 'REDUCTION' | translate }} </span>
          </div>
        </div>
        </div>
    
    
      <ng-template #noItems>
      </ng-template>
   -->

<!-- <app-test-menu (projPassToParent)='projPassFromMenu($event)'></app-test-menu> -->
<div *ngIf="flat && offer">
  <h1> <span>הצעה לכבוד:</span> {{ offer.client.name }} </h1>
  <div  mat-stroked-button class="image-holder image-with-staus" *ngIf="this.offer.user">
    <!-- <div class="image-holder image-with-staus" *ngIf="this.offer.user.phone"> -->
    <span class="inner-image-holder" *ngIf="this.buildingUid">
      <!-- <img src="this.user.photoURL" alt=""> -->
      <app-gallery [galleryId]="'1'" [section]="this.buildingUid +'contactMenPic'" [autoPlay]="false" [showThumbs]="false"
        class="contact-men-pic"></app-gallery>
    </span>
    <div class="buttons-holder" *ngIf="this.offer.user">
      <div class="contact-men"> לשאול את <span>{{ this.offer.user.displayName }}</span></div>
      <!-- <div class="contact-men"> לשאול את {{ this.user.displayName }}</div> -->
      <a class="whatsapp" href="https://api.whatsapp.com/send?phone={{ this.offer.user.phone }}" target="_blank"></a>
      <!-- <a class="whatsapp" href="https://api.whatsapp.com/send?phone={{ this.user.phoneNumber }}" target="_blank"></a> -->
      <a class="phone" href="tel:{{ this.offer.user.phone }}"></a>
      <!-- <a class="phone" href="tel:{{ this.user.phoneNumber }}"></a> -->
    </div>
  </div>
  <div class="proj-comp-titles">
    {{ this.companyTitle }} - <span> {{ this.projectTitle }} </span>

    <div class="flat-properties-header-holder"><span>{{ 'BUILDING' | translate
    }}:</span>
  <div>{{ flat.buildName }}</div>

  <span>{{ 'FLAT-NUMBER' |
    translate }}:
    {{ flat.number }}</span>

</div>
  </div>
  <div>
    <div>
      <!-- <div class="image-holder image-with-staus" *ngIf="this.contactPhoneNumber && removeAllMenu === 'true'">
    <span class="inner-image-holder" *ngIf="this.buildUid">
      <img src="this.user.photoURL" alt="">
      <app-gallery [galleryId]="'1'" [section]="this.buildUid +'contactMenPic'" [autoPlay]="false" [showThumbs]="false"
        class="contact-men-pic"></app-gallery>
    </span>
    <div class="buttons-holder">
      <div class="contact-men"> לשאול את {{ contactName }}</div>
      <a class="whatsapp" href="https://api.whatsapp.com/send?phone={{ contactPhoneNumber }}" target="_blank"></a>
      <a class="phone" href="tel:{{ contactPhoneNumber }}"></a>
    </div>
  </div> -->
      <!-- <a *ngIf="!removeCloseButton" class="close-section close-fixed close-display" href="javascript:;"
    (click)="goToBuilding()"></a> -->
      <!-- <input type="text" [value]="routeNavigate" class="hide-url" #userinput>
  <button *ngIf="removeAllMenu === 'false'" (click)="copyInputMessage(userinput)" class="share-url"></button>
  <button *ngIf="removeAllMenu === 'false'" (click)="openDialog()" class="offer-btn"></button> -->


      <!-- <a *ngIf="removeAllMenu === 'false'" class="fa-whatsapp share-whatsapp">
    <div class="whatsapp-menu-trigger" (click)="showPhoneF()">
      <ul class="whatsapp-menu" *ngIf="showPhone">
        <li (click)="showPhoneNumber = !showPhoneNumber"><a href="javascript:;">מספר טלפון</a></li>
        <li><a href="https://api.whatsapp.com/send?&text={{ routeNavigate + '?m=all' }}" target="_blank">רשימת
            משתמשים</a></li>
      </ul>
    </div>

    <div class="add-phone-numbrer" *ngIf="showPhoneNumber">
      <mat-form-field appearance="fill">
        <select matNativeControl required (change)="onChangeAreaCode($event.value)">
          <option  type="number" *ngFor="let code of areaCodes" value="{{ code }}">{{ code
            }}
          </option>
        </select>
      </mat-form-field>

      <input [(ngModel)]='phoneNumber' type="number" pattern="/[^\d+]/" placeholder="050 1111111"
        name="phone-number">
      <a class="btn"
        href="https://api.whatsapp.com/send?text={{ routeNavigate + '?m=all' + '&phone='+ areaCode + phoneNumber }}"
        target="_blank">שלח</a>
    </div>
  </a>

  <span class="show-coppy-note" [class.active]=showCopyNote>{{ 'COPIED' | translate }}</span>
  <div *ngFor="let flatPropertie of flatProperties" class="flat-properties-container" [class.no-menu]="removeAllMenu === 'true'"> -->

    





      <div class="flat-properties-container no-menu">
        <div class="flat-details-holder">

          <div *ngIf="items;else noItems" class="list-flats flat-composite-padding">
            <div class="collection" class="flat dark-background">
              <ul class="general-flat-propeties n">
                <li *ngIf="flat.airDirection" class="general-flat-air-direction"><span>{{ 'AIR-DIRECTION' | translate
                    }}</span>{{ flat.airDirection }}
                </li>
                <li *ngIf="flat.floorNumber" class="general-flat-floor-number"> <span>{{ 'FLOOR' | translate }}</span>
                  {{
                  flat.floorNumber }}
                </li>
                <li *ngIf="flat.flatSize" class="general-flat-area">
                  <span>{{ 'APARTMENT-AREA' | translate }}</span> {{ flat.flatSize }}
                </li>
                <li *ngIf="flat.balconiesSize" class="general-flat-area">
                  <span>{{ 'BALCONIES-AREA' | translate }}</span> {{ flat.balconiesSize }}
                </li>
                <li *ngIf="flat.gardenSize" class="general-flat-area">
                  <span>{{ 'GARDEN-AREA' | translate }}</span> {{ flat.gardenSize }}
                </li>
                <li *ngIf="flat.numberOfRooms" class="general-flat-room-quantity">
                  <span>{{ 'NUMBER-OF-ROOMS' | translate }}</span> {{ flat.numberOfRooms }}
                </li>
              </ul>
              <!-- בניין: {{ buildName }}
        מספר דירה: {{ item.number }}
        קומה: {{ item.floorNumber }} -->

            </div>
          </div>
          <div *ngIf="flat.freeText && flat.freeText !== ' '" class="flat-properties dark-background">
            <h3 class="title second-title slide" (click)="fullScreen = !fullScreen"
              [class.full-screen-view]="fullScreen">{{ 'SPECIFICATION' | translate }}
              <div class="increase-size">
                <span></span>
              </div>
            </h3>

    
            <div class="scroll-holder specification-holder" [class.full-screen-view]="fullScreen">
              <ul [class.active]="showContent" class="flat-details-content">
                <li [innerHtml]="flat.freeText | safe: 'html'">
    
                </li>
              </ul>
            </div>
          </div>
          <!-- </div> -->
          <!-- <div *ngIf="editState && itemToEdit.id == flat.id" class="files"> -->



        </div>


        <div class="flat-composite-padding flat-composite-bottom">


          <mat-tab-group mat-align-tabs="start">
            <div *ngIf="flat">
              <mat-tab label="{{ 'SPIRIKAL' | translate }}" *ngIf="!desktopResolution">
                <div class="collection da-iframe panorama-holder" [class.full-screen-view]="fullScreenSpirical">
                  <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder"
                    [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '></iframe>' | safe: 'html'">
                  </div>
                </div>
                <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigSpirical()">
                  <span></span>
                </div>
              </mat-tab>
              <mat-tab *ngIf="flat.curFloorPanorama" label="{{ 'VIEW' | translate }}">
                <!-- <mat-tab label="נוף"> -->
                <div class="collection" class="panorama-holder" [class.full-screen-view]="fullScreenSpirical">
                  <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder"
                    [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '?s=' + flat.curFloorPanorama + '></iframe>' | safe: 'html'">
                  </div>
                </div>
                <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigSpirical()">
                  <span></span>
                </div>
              </mat-tab>
              <mat-tab label="{{ 'PLAN' | translate }}" *ngIf="flatProperties">
                <app-gallery [galleryId]="'1'" [section]="flatProperties.id+'images'" [resizeDrag]="true"
                  [autoPlay]="true" [showThumbs]="true" class="list-static simple-gall build-simple-gal plan-holder"
                  [class.full-screen-view]="fullScreenDrawing"></app-gallery>

                <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigDrawing()">
                  <span></span>
                </div>
              </mat-tab>
              <mat-tab label="{{ 'SIMULATIONS' | translate }}" *ngIf="proj">
                <app-gallery *ngIf="flat.shareflatgallery" [galleryId]="'1'" [class.full-screen-view]="fullScreenGallery"
                  [section]="proj[0].uid+'interiorSimulations'" [autoPlay]="true" [showThumbs]="true"
                  class="list-static flat-details shared-flat-gallery scroll">
                </app-gallery>
                <app-gallery *ngIf="flat.shareflatgalleryOfBuilding" [class.full-screen-view]="fullScreenGallery" [galleryId]="'1'"
                  [section]="buildingUid+'interiorSimulations'" [autoPlay]="true" [showThumbs]="true"
                  class="list-static flat-details shared-flat-gallery scroll">
                </app-gallery>

                <app-gallery *ngIf="flatProperties" [galleryId]="'1'"
                  [section]="flatProperties.id+'interiorSimulations'" [class.full-screen-view]="fullScreenGallery" [autoPlay]="true" [showThumbs]="true"
                  class="list-static flat-details scroll"></app-gallery>

                  <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigGallery()">
                    <span></span>
                  </div>
              </mat-tab>
              <ng-template *ngIf="flatProperties">
                <mat-tab *ngIf="flatProperties.flatInterior" label="{{ 'INTERIOR-TOUR' | translate }}">
                  <div *ngIf="flatProperties.flatInterior" class="panorama-holder"
                    [class.full-screen-view]="fullScreenInterior">
                    <div class="view-from-floor-panorama-holder flat-interior"
                      [innerHtml]="'<iframe src=' + flatProperties.flatInterior + '></iframe>' | safe: 'html'">
                    </div>
                  </div>
                  <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigInterior()">
                    <span></span>
                  </div>
                </mat-tab>
              </ng-template>

            </div>
          </mat-tab-group>
          <div class="price-note" *ngIf="offer.price"> <span>מחיר:</span> {{ offer.price }}</div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #noItems>
</ng-template>